// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__eTj-Z","selected":"Chip_selected__19_1S"};